<template>
    <div class="h-screen w-full fixed top-0 left-0 flex flex-col items-center justify-start md:justify-center bg-gray-opacity-100 overflow-y-scroll"
         tabindex="0" @keydown.esc="$emit('close')" @click="$emit('close')">
        <div @click.stop class="relative bg-white rounded-lg shadow p-5 m-4 w-11/12 sm:w-9/12 max-w-full md:max-w-md text-center">
            <button @click="$emit('close')" type="button" class="absolute right-0 top-0 mt-3 mr-3 sm:mr-0 sm:mt-0 sm:-mr-16 bg-darkGreen-200 hover:bg-darkGreen-100 p-2 sm:p-3 rounded-lg">
                <img src="assets/img/close.svg" alt="Close" class="w-3 sm:w-auto" />
            </button>
            <header class="flex flex-col items-center justify-between mb-3">
                <slot name="header-top"/>
                <h4 class="text-xl text-black font-bold">{{ title }}</h4>
                <p v-if="description" class="my-3 md:my-6">{{ description }}</p>
                <slot name="header-bottom"/>
            </header>
            <section class="modal-body max-w-full text-center font-black text-sm ov">
                <slot/>
            </section>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: null
            },
            description: {
                type: String,
                default: null
            },
        },

        mounted() {
            this.$el.focus();
            document.body.classList.add('overflow-hidden')
        },

        destroyed() {
            document.body.classList.remove('overflow-hidden')
        }
    }
</script>
